<template>
  <el-drawer
    title="我是标题"
    size="300px"
    :visible.sync="drawer"
    :with-header="false"
    :before-close="handleClose"
  >
    <div class="userInfo">
      <div class="top">
        <div class="userContent">
          <el-avatar icon="el-icon-user-solid"></el-avatar>
          <span>{{ userInfo?.nameEN || userInfo?.userName }}</span>
        </div>
        <div class="msg">
          压力不是有人比你努力，而是比你牛叉几倍的人依然在努力
        </div>
      </div>
      <div class="middle">
        <div class="panel">
          <div class="item">
            <div class="label">角色</div>
            <div class="num"> {{ userInfo?.typeDescription }}</div>
          </div>
          <div class="item">
            <div class="label">权限</div>
            <div class="num">
              <span
                v-for="item in userInfo?.userRoleName"
                :key="item"
              >
                {{ item }}
              </span>
            </div>
          </div>
          <div class="item">
            <div class="label">编码</div>
            <div class="num">{{ userInfo?.code }}</div>
          </div>
          <div class="item">
            <div class="label">电话</div>
            <div class="num">{{ userInfo?.phone }}</div>
          </div>
          <div class="item">
            <div class="label">邮箱</div>
            <div class="num" style="color: green;">{{ userInfo?.email }}</div>
          </div>
          <div class="item">
            <div class="label">地点</div>
            <div class="num">{{ country }}</div>
          </div>
          <div class="item">
            <div class="label">状态</div>
            <div class="num">{{ userInfo?.isActived ? "使用中" : "停用" }}</div>
          </div>
        </div>
      </div>
      <div class="bottom" @click="logout">退出</div>
    </div>
  </el-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UserDrawer',
  props: {
    drawer: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'addressDropOption']),
    country() {
      const label = this.addressDropOption?.find(a => a.value === this.userInfo?.countryId)?.label
      return label
    }
  },
  methods: {
    handleClose(done) {
      if (typeof done === 'function') {
        done()
      }
      this.$emit('close')
    },
    logout() {
      this.$emit('exit')
    }
  }
}
</script>
<style scoped>
.line {
  width: 100%;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}
.line:hover {
  color: #409eff;
}
.userInfo {
  min-height: 100%;
  width: 300px;
  background-color: rgb(233, 238, 246);
  position: relative;
}
.top {
  width: 100%;
  height: 140px;
  overflow: hidden;
  background-color: transparent;
  background-image: url("~@/assets/PersonalCenterblue.png");
}
.userContent {
  height: 90px;
  display: flex;
  align-items: center;
}
.userContent /deep/ .el-avatar {
  margin-left: 20px;
}
.userContent span {
  color: rgb(255, 255, 255);
  font-size: 14px;
  margin-left: 10px;
}
.money {
  color: rgb(255, 255, 255);
  font-size: 14px;
  margin-left: 10px;
}
.msg {
  width: 260px;
  height: 50px;
  color: rgb(255, 255, 255);
  font-size: 14px;
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 5px;
  text-align: left;
}
.middle {
  width: 100%;
  height: calc(100% - 190px);
  background-color: rgb(233, 238, 246);
}
.panel {
  background-color: rgb(255, 255, 255);
  margin: 8px;
}
.bottom {
  width: 100%;
  height: 40px;
  background: blue;
  align-self: flex-end;
  background-color: #ffffff;
  font-size: 12px;
  line-height: 40px;
  text-align: center;
  position: absolute;
  bottom: 0;
  cursor: pointer;
}
.item {
  height: 30px;
  padding: 0 15px;
  display: flex;
  font-size: 12px;
  line-height: 30px;
}
.item .label {
  min-width: 60px;
  text-align: left;
}
.item .num {
  min-width: 195px;
  text-align: left;
}
.change {
  transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -webkit-transform: rotate(-90deg);
  cursor: pointer;
}
</style>
